import { createTheme } from "@mui/material/styles";
import { orange } from "@mui/material/colors";

const fontWeightsClasses = {
  "&.font-w-100": {
    fontWeight: 100,
  },
  "&.font-w-200": {
    fontWeight: 200,
  },
  "&.font-w-300": {
    fontWeight: 300,
  },
  "&.font-w-400": {
    fontWeight: 400,
  },
  "&.font-w-500": {
    fontWeight: 500,
  },
  "&.font-w-600": {
    fontWeight: 600,
  },
  "&.font-w-700": {
    fontWeight: 700,
  },
  "&.font-w-800": {
    fontWeight: 800,
  },
  "&.font-w-900": {
    fontWeight: 900,
  },
};

const fontColorClasses = {
  "&.white-color": {
    color: "#fff",
  },
  "&.gray-color": {
    color: "#A9A9A9",
  },
  "&.gray-color-2": {
    color: "#9CA3AF",
  },
  "&.gray-color-3": {
    color: "#BCBEBE",
  },
  "&.gray-color-4": {
    color: "#BCB7B7",
  },
  "&.gray-color-5": {
    color: '#999999',
  },
  "&.black-color": {
    color: "#242424",
  },
  "&.black-color-2": {
    color: "#111111",
  },
  "&.black-color-3": {
    color: "#333333",
  },
  "&.black-color-4": {
    color: "#000000",
  },
  "&.brand-color": {
    color: "#f4032d",
  },
  "&.purple-color": {
    color: "#464255",
  },
  "&.blue-color": {
    color: "#0A2640",
  },
};

const commonTextClasses = {
  "&.text-nowrap": {
    whiteSpace: "nowrap",
  },
  "&.text-center": {
    textAlign: "center",
  },
  "&.text-right": {
    textAlign: "right",
  },
};

export const theme = createTheme({
  status: {
    danger: orange[500],
  },
  palette: {
    primary: {
      main: "#000",
      contrastText: "#464255",
    },
    secondaryText: {
      main: "#fff0",
      contrastText: "#A3A3A3",
    },
    buttonNormal: {
      main: "#F3F2F7",
      contrastText: "#464255",
      ":disabled": {
        backgroundColor: "#ff0",
      },
    },
    pricingBoxColors: {
      largePackBackgroundColor: "#f0ffea",
      webPackBackgroundColor: "#fdeafe",
      singleImageBackgroundColor: "#ececec",
      largePackSelectedBackgroundColor: "#e5f2de",
      webPackSelectedBackgroundColor: "#f4e1f5",
      singleImageSelectedBackgroundColor: "#e0dddd",
      singleImageSelectedBackgroundColorsssss:
        "linear-gradient(180deg, #242424 0%, #270202 100%)",
    },
    appColor: {
      main: '#fff0',
      contrastText: '#464255',
    },
  },
  components: {
    // Name of the component
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          border: "auto",
          textTransform: "none",
          // boxShadow: "none",
          // textTransform: "none",
          "&.mozPrimaryColorButton": {
            color: "0084ffff",
            backgroundColor: "transparent",
            borderColor: "white",
            "&:hover": {
              backgroundColor: "var(--ep-blue)",
              borderColor: "var(--ep-blue) !important",
            },
            "&:disabled": {
              backgroundColor: "rgba(255,255,255,0.25)",
            },
            "&:focus": {
              backgroundColor: "var(--ep-blue)",
              borderColor: "var(--ep-blue) !important",
            },
            "&.mozButtonSelected": {
              backgroundColor: "var(--ep-blue)",
              borderColor: "var(--ep-blue) !important",
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          //   paddingRight: "32px",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          //   "transparent-dialog": {
          //     backgroundColor: "transparent",
          //   },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          margin: "5px 0",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "& fieldset": {
            borderColor: "#464255",
          },
          "& fieldset.rounded": {
            borderRadius: 16,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "input:disabled": {
            cursor: "not-allowed",
          },
          ".Mui-disabled": {
            cursor: "not-allowed",
          },
        },
      },
      defaultProps: {
        typographyprops: {
          variant: "xlSize",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          // "&.BrandRoundIconContainer": {
          //   borderRadius: "50%",
          //   padding: "7px",
          //   backgroundColor: "inherit",
          //   "&:hover": {
          //     backgroundColor: "inherit",
          //   },
          // },
        },
        // Name of the slot
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: '#bcbebe',
          fontWeight: '500',
          fontSize: '0.875rem',
          fontFamily: "Poppins",
          '&.Mui-selected': {
            color: '#f4032d',
            backgroundColor: 'transparent',
          },
          '&.Add-border': {
            borderRight: '1px solid rgba(0, 0, 0, 0.1)',
            paddingRight: '34px',
            // marginRight: '16px',
            paddingLeft: '30px'
          },
        },
      },
    },
    MuiBadge: {
      styleOverrides: {
        // Name of the slot
        // badge: {
        //   borderRadius: "50%",
        //   backgroundColor: "#5d5d5d",
        //   color: "white",
        //   right: "-10%",
        //   top: "-14%",
        //   fontSize: "13px",
        // },
      },
    },
    MuiTypography: {
      styleOverrides: {
        // Name of the slot
        root: {
          "&.mozHeaderNavTypo": {
            color: "var(--ep-blue)",
            textDecoration: "none",
            "&:hover": {
              color: "#0087fd92",
              textDecoration: "underline",
              textDecorationThickness: "2px",
              textUnderlineOffset: "6px",
            },
            "&:focus": {
              color: "var(--ep-blue)",
            },
            "&.mozNavSelected": {
              color: "var(--ep-blue)",
              textDecoration: "underline",
              textDecorationThickness: "2px",
              textUnderlineOffset: "6px",
            },
          },
          "&.mozFooterNavTypo": {
            color: "#A9A9A9",
            textDecoration: "none",
            "&:hover": {
              color: "#242424",
            },
            "&:focus": {
              color: "#242424",
            },
            "&.mozNavSelected": {
              color: "#242424",
            },
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          //   "&.Mui-selected": {
          //     backgroundColor: "#b8dcfa26",
          //   },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          //   background: "#fff",
          //   "&:hover": {
          //     background: "#fff",
          //   },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        ".py0": {
          paddingBottom: "0px !important",
          paddingTop: "0px !important",
        },
        ".rounded-2": {
          borderRadius: 8,
        },
        ".rounded-3": {
          borderRadius: 16,
        },
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        color: 'red',
        fontWeight: 'bold',
        fontSize: '14px',
        '&.Mui-selected': {
          color: '#0BB1A9',
          backgroundColor: 'transparent',
        },
        '&.Add-border': {
          borderRight: '1px solid rgba(0, 0, 0, 0.1)',
          paddingRight: '34px',
          // marginRight: '16px',
          paddingLeft: '30px'
        },

      },
    },
  },

  typography: {
    xxxxxsSize: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontSize: "9px",
      lineHeight: "12px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      "&.font-great-vibes": {
        fontFamily: `Great Vibes , cursive`,
      },
      "&.line-h-extended": {
        lineHeight: "18px",
      },
    },
    xxxxsSize: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontSize: "12px",
      lineHeight: "16px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      "&.font-great-vibes": {
        fontFamily: `Great Vibes , cursive`,
      },
      "&.line-h-extended": {
        lineHeight: "18px",
      },
    },
    xxxsSize: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "16px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      "&.font-great-vibes": {
        fontFamily: `Great Vibes , cursive`,
      },
      "&.line-h-extended": {
        lineHeight: "20px",
      },
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "12px",
        lineHeight: "14px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "12px",
        lineHeight: "14px",
      },
    },
    xxsSize: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontSize: "16px",
      lineHeight: "16px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      "&.font-great-vibes": {
        fontFamily: `Great Vibes , cursive`,
      },
      "&.line-h-extended": {
        lineHeight: "24px",
      },
      "&.line-height-extended-2": {
        lineHeight: "30px",
      },
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "13px",
        lineHeight: "16px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "15px",
        lineHeight: "18px",
      },
    },
    xsSize: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontSize: "18px",
      lineHeight: "24px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      "&.font-great-vibes": {
        fontFamily: `Great Vibes , cursive`,
      },
      "&.line-h-extended": {
        lineHeight: "24px",
      },
      "&.line-h-extended-2": {
        lineHeight: "27px",
      },
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "14px",
        lineHeight: "16px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "16px",
        lineHeight: "18px",
      },
    },
    sSize: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontSize: "20px",
      lineHeight: "20px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      "&.font-great-vibes": {
        fontFamily: `Great Vibes , cursive`,
      },
      "&.line-height-condensed": {
        lineHeight: "16px",
      },
      "&.line-height-extended": {
        lineHeight: "24px",
      },
      "&.line-height-extended-2": {
        lineHeight: "30px",
      },
      "&.line-height-extended-3": {
        lineHeight: "36px",
      },
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "16px",
        lineHeight: "18px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "16px",
        lineHeight: "18px",
      },
      "@media only screen and (min-width: 768px) and (max-width: 1023px)": {
        fontSize: "18px",
        lineHeight: "20px",
      },
    },
    mSize: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontSize: "24px",
      lineHeight: "28px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      "&.font-great-vibes": {
        fontFamily: `Great Vibes , cursive`,
      },

      "&.line-height-condensed": {
        lineHeight: "16px",
      },
      "&.line-height-extended": {
        lineHeight: "32px",
      },
      "&.line-height-extended-1": {
        lineHeight: "56px",
      },
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "18px",
        lineHeight: "22px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "18px",
        lineHeight: "22px",
      },
      "@media only screen and (min-width: 768px) and (max-width: 1023px)": {
        fontSize: "18px",
        lineHeight: "22px",
      },
      "@media only screen and (min-width: 1024px) and (max-width: 1439px)": {
        fontSize: "20px",
        lineHeight: "22px",
      },
    },
    lSize: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontSize: "32px",
      lineHeight: "32px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      "&.font-great-vibes": {
        fontFamily: `Great Vibes , cursive`,
      },
      "&.line-h-extended-1": {
        lineHeight: `60px`,
      },
      "&.line-h-extended-2": {
        lineHeight: `48px`,
      },
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "20px",
        lineHeight: "24px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "20px",
        lineHeight: "24px",
      },
      "@media only screen and (min-width: 768px) and (max-width: 1023px)": {
        fontSize: "20px",
        lineHeight: "24px",
      },
      "@media only screen and (min-width: 1024px) and (max-width: 1439px)": {
        fontSize: "25px",
        lineHeight: "30px",
      },
    },
    xlSize: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontSize: "48px",
      lineHeight: "60px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      "&.font-great-vibes": {
        fontFamily: `Great Vibes , cursive`,
        fontSize: "20px",
        lineHeight: "28px",
      },
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "28px",
        lineHeight: "32px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "32px",
        lineHeight: "45px",
      },
      "@media only screen and (min-width: 768px) and (max-width: 1023px)": {
        fontSize: "32px",
        lineHeight: "45px",
      },
      "@media only screen and (min-width: 1024px) and (max-width: 1439px)": {
        fontSize: "40px",
        lineHeight: "44px",
      },
    },
    xxlSize: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontSize: "50px",
      lineHeight: "75px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      "&.font-great-vibes": {
        fontFamily: `Great Vibes , cursive`,
      },
      "&.line-h-condensed-1": {
        lineHeight: `60px`,
      },
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "32px",
        lineHeight: "36px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "32px",
        lineHeight: "36px",
      },
      "@media only screen and (min-width: 768px) and (max-width: 1023px)": {
        fontSize: "32px",
        lineHeight: "36px",
      },
      "@media only screen and (min-width: 1024px) and (max-width: 1439px)": {
        fontSize: "42px",
        lineHeight: "52px",
      },
    },
    xxxlSize: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontSize: "64px",
      lineHeight: "76px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      "&.font-great-vibes": {
        fontFamily: `Great Vibes , cursive`,
      },
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "42px",
        lineHeight: "50px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "42px",
        lineHeight: "55px",
      },
      "@media only screen and (min-width: 768px) and (max-width: 1023px)": {
        fontSize: "42px",
        lineHeight: "55px",
      },
      "@media only screen and (min-width: 1024px) and (max-width: 1439px)": {
        fontSize: "52px",
        lineHeight: "66px",
      },
    },
  },
  shape: {
    borderRadiusPrimary: (val) => val,
  },
  shape: {
    borderRadius: (val) => 2 * val,
  },
});
